export default "__VITE_ASSET__BohsGnOk__"